<aside class="offsidebar offsidebar-custom" id="notificationDiv" tabindex="0">
    <nav>
        <div role="tabpanel" class="custom-tabpanel">
            <!-- Nav tabs-->

            <ul role="tablist" class="nav nav-tabs nav-justified"style="margin-top: 5%;margin-left: 5%;">
                    <li id="notificationId" *ngIf="this.bs.isActiveNotification" role="presentation" [ngClass]="this.bs.NotificationClass" (click)="openNotification()">
                        <a href="#app-settings" aria-controls="app-settings" role="tab" data-toggle="tab" aria-expanded="true">
                            <span>   {{bs.getResource('rbkey_NtfctnsLBL')}} <span class="red-circle" *ngIf="bs.UnreadNotificationCount >0"></span>
                        </span>
                         </a>
                    </li>
                    <li id="announcementId" role="presentation" [ngClass]="this.bs.AnnouncementClass"  (click)="openAnnouncement()">
                        <a href="#app-chat" aria-controls="app-chat" role="tab" data-toggle="tab" aria-expanded="false">
                            <span>       {{bs.getResource('rbkey_AnnncmntsLBL')}}   <span class="red-circle" *ngIf="bs.UnreadAnnouncementCount >0" ></span>
                        </span>
                         </a>
                    </li>
                </ul>


            <!-- Tab panes-->
            <div class="tab-content">
                <item-notification *ngIf="EnableNotification"></item-notification>
                <announcement *ngIf="EnableAnnouncement"></announcement>
            </div>
        </div>
    </nav>
</aside>
